import React from 'react';
import {Route} from 'react-router-dom';
import DocumentUploadHistoryView from './components/DocumentUploadHistoryView';

export const DocumentRouteConstants = {
  ROOT_URI: '/agent/document-upload-history',
};

const DocumentRoutes = () => {
  return <Route exact path={DocumentRouteConstants.ROOT_URI} render={() => <DocumentUploadHistoryView />} />;
};

export default DocumentRoutes;
